<template>
	<div
		class="offer-verified__travel-details"
		:class="{ 'offer-verified__travel-details--hotel-only': !isPackage }"
	>
		<template v-if="isPackage">
			<TravelDetails
				class="offer-verified__travel-details-outbound"
				:unverified-date="offerData.StartDate"
				:flight-segments="outboundFlightSegments || []"
				:flight="offerData.OutboundFlight"
			/>
			<TravelDetails
				class="offer-verified__travel-details-inbound"
				:unverified-date="offerData.EndDate"
				:flight-segments="inboundFlightSegments || []"
				:flight="offerData.InboundFlight"
				inbound
			/>
		</template>
		<template v-else>
			<TravelDateAttribute
				:icon="['fa-regular', 'fa-calendar-range']"
				class="offer-verified__hotel-only-outbound"
				:text="formattedText"
			/>
		</template>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { formatDateWeekdayPoint } from '@utils/dateTimeUtils';
import TravelDetails from '@lmt-rpb/TravelDetails/TravelDetails.vue';
import type { VerifiedFlightSegment, MergedOfferItemData } from '@interfaces/offer';
import { NBSP, NDASH } from '@global-js/constants';
import { useOfferVerifiedInjection } from '../injectionProps';
import TravelDateAttribute from '@lmt-rpb/Atoms/TravelDateAttribute/TravelDateAttribute.vue';

interface Props {
	offerData: MergedOfferItemData;
	outboundFlightSegments?: VerifiedFlightSegment[];
	inboundFlightSegments?: VerifiedFlightSegment[];
}

const props = defineProps<Props>();
const { isPackage } = useOfferVerifiedInjection();
const formattedOutbound = computed(() => formatDateWeekdayPoint(props.offerData.StartDate));
const formattedInboundDate = computed(() => formatDateWeekdayPoint(props.offerData.EndDate));

const formattedText = computed(() => `${formattedOutbound.value}${NBSP}${NDASH}${NBSP}${formattedInboundDate.value}`);
</script>

<style lang="scss" scoped>
.offer-verified {
	&__travel-details {
		width: 100%;
		display: flex;
		gap: 0.8rem;
		justify-content: space-between;

		& > * {
			flex: 1;
		}

		@include media-query-up($breakpoint-small) {
			gap: 1.6rem;
		}
	}

	&__travel-details-outbound,
	&__travel-details-inbound {
		width: 100%;
	}

	@media (min-width: $breakpoint-small) {
		&__travel-details {
			justify-content: start;
			font-size: $font-small-1;
			font-weight: $font-weight-semibold;
			color: $color-text;
			flex-direction: column;
		}
	}

	@media (min-width: $breakpoint-medium) {
		&__travel-details {
			flex-direction: row;
		}

		&__travel-details-outbound-unverified {
			margin-bottom: 0;
		}
	}
}
</style>
